import { Component, AfterViewInit } from '@angular/core';
import { select } from '@ngrx/core';
import { FieldType  } from '@ngx-formly/core';
import * as _ from 'lodash';

// multiple checkbox render

// do not use [formControl]="formControl" as it will set value true/false and break this custom component
// you have to implement custom input, the required validation is not working
@Component({
  selector: 'tr-multicheckbox',
  template: `
  <div *ngFor="let option of to.options; let i = index;" class="checkbox">
    <label class="custom-control custom-checkbox d-block" [for]="id + '_' + i">
        <input  type="checkbox"
            [id]="id + '_' + i"
            [name]="id"
            [value]="option.key"
            class="custom-control-input"
            [checked]="getCheckedValue(formControl, option.key)"
            (change)="onChange(option.key, $event.target.checked)"
            [disabled]="to.disabled"
             >
        <span class="custom-control-label">{{ option.value }}</span>
        <span class="custom-control-indicator"></span>
    </label>
  </div>
  <i *ngIf="to.displayCorrect" class="fa fa-check text-success fa-2x" aria-hidden="true"></i>
  <i *ngIf="to.displayWrong" class="fa fa-times text-danger fa-2x" aria-hidden="true"> </i>
  `,
})

// class="custom-control custom-checkbox d-block"
// <i *ngIf="checkCorrectAnswer(formControl, to.options) == null ? null : checkCorrectAnswer(formControl, to.options)" class="fa fa-check text-success fa-3x" aria-hidden="true"></i>
// <i *ngIf="checkCorrectAnswer(formControl, to.options) == null ? null : !checkCorrectAnswer(formControl, to.options)" class="fa fa-times text-danger fa-3x" aria-hidden="true"></i>

// OnInit, DoCheck, AfterContentInit, AfterContentChecked, AfterViewInit, AfterViewChecked, OnDestroy
export class MulticheckboxComponent extends FieldType implements  AfterViewInit {

  //private timeout = this.to.timedelay;
  private formControlValue = null;// save form conrol vals IDs instead of true/false

  ngAfterViewInit() {
    super.ngAfterViewInit();

    if (this.to.timedelay !== undefined && this.to.timedelay > -1)
    {
      var milliseconds  = (this.to.timedelay) * 1000;
      setTimeout(() => {this.to.disabled = false}, milliseconds );// enable multicheckbox after x seconds
      console.log("mc: set time delay: " + this.to.timedelay + " seconds");
    }
    else
    {
      console.log("mc: timedelay not found");
    }

  }


  private checkCorrectAnswer(formControl, options) {
    console.log("checking");

    if (_.has(this.field.templateOptions, 'correctanswers') && this.field.templateOptions.correctanswers != null && this.field.templateOptions.correctanswers != '')
    {

      //console.log("correct answers");
      //console.log(this.field.templateOptions.correctanswers);

      var correctAnsArr = this.field.templateOptions.correctanswers.split(','); // must be in array

      //console.log("selected answers");
      //console.log(this.formControlValue);

        if (this.formControlValue != null && this.formControlValue != '')
        {
          // must be an array
          var selectedAnsArr;
          if (Array.isArray(this.formControlValue))
          {
            selectedAnsArr = this.formControlValue; // must be in array
          }
          else
          {
            if (this.formControlValue != '')
            {
              // single string value
              selectedAnsArr = this.formControlValue.split(' ');// must be in array
            }
            else
            {
              // blank
              selectedAnsArr = [];// must be in array
            }
          }

          selectedAnsArr = selectedAnsArr.sort();// sort array in order
          correctAnsArr = correctAnsArr.sort(); // sort array in order

          var same = (selectedAnsArr.length === correctAnsArr.length && selectedAnsArr.every(function (value, index) { return value === correctAnsArr[index] }));
          //console.log('correct answer?');
          //console.log(same);
          return same; // true or false

        }
        else
        {
          return null;
        }
    }
    else
    {
      return null;
    }


  }

  private getCheckedValue(formControl, key) {
    var formControlVals = formControl.value;
    if (this.formControlValue == null)
    {
      if(Array.isArray(formControlVals))
      {
        this.formControlValue = formControlVals;
      }
      else
      {
        if (formControlVals != null && formControlVals != '') {
          this.formControlValue = formControlVals.split(','); // convert comma sepearted string to an array
        }
      }

    }
    var re = (this.formControlValue != null) ? this.formControlValue.indexOf(key) > -1 : false;
    return re;
  }

  private onChange(value, checked) {
    if(checked)
    {
      // when this checkbox is checked, remove it from existing selected checkbox array, and add it as the last element of the array
      if(this.formControlValue != null)
      {
         newVal = this.arrayRemove(value, this.formControlValue);
         newVal.push(value);// push the latest value to the array
      }
      else
      {
         newVal = [value];
      }
      this.formControlValue = newVal.filter(Boolean);
      // [formControl]="formControl" : if patch value, the render is not working, but saving is working
      // [formControl]="formControl" : if not patch value, the render is working, but saving is not working
      this.formControl.patchValue(this.formControlValue); // remove "" blank element in array
      this.formControl.markAsTouched();
    }
    else
    {
      // when this checkbox is not checked, remove it from existing selected checkbox array
      if(this.formControlValue != null)
      {
        var newVal = this.arrayRemove(value, this.formControlValue);
        this.formControlValue = newVal.filter(Boolean);

        // [formControl]="formControl" : if patch value, the render is not working, but saving is working
        // [formControl]="formControl" : if not patch value, the render is working, but saving is not working
        this.formControl.patchValue(this.formControlValue);// array, remove "" blank element in array
        this.formControl.markAsTouched();
      }
    }

  }

  // when checkbox is selected, set checkbox to be true on UI
  private stringToArr(option, commaValues) {
      var ar;
      if(Array.isArray(commaValues))
      {
        ar = commaValues;
      }
      else
      {
        ar = commaValues.split(','); // convert comma sepearted string to an array
      }

      if(ar.indexOf(option) > -1)
      {
        return true;
      }
      else
      {
        return false;
      }
  }

  // manipulate selected checkbox array for posting to the portal API
  private arrayRemove(option, commaValues) {
      var ar;
      if(Array.isArray(commaValues))
      {
        ar = commaValues;
      }
      else
      {
        ar = commaValues.split(','); // convert comma sepearted string to an array
      }

      if (ar.indexOf(option) > -1) {
        // remove value from array

        ar.splice( ar.indexOf(option), 1 );
      }
      // return array
      return ar;
  }

}



// WEBPACK FOOTER //
// ./src/app/stage/containers/multicheckbox/multicheckbox.component.ts